// @flow
export { default } from './Page';
